import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

export default class TargetDescription extends React.Component {
  static propTypes = {
    target: PropTypes.shape({
      characteristic: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        content: PropTypes.object
      })
    })
  }

  state = {
    active: 'insight'
  }

  setActive = (type) => {
    this.setState({
      active: type
    });
  }

  render() {
    const { active } = this.state;
    const { name, description, content } = this.props.target.characteristic;

    return (
      <Fragment>
        <div className="personal-target-grouping-targets-body-header">
          <h4>{ name }</h4>

          {!!content['student_tip'] && (
            <span>
              <a
                className={active === 'insight' ? 'active' : ''}
                onClick={() => this.setActive('insight')}
                href="javascript:void(0)"
              >
                {trans`INSIGHTS`}
              </a>

              <a
                className={active === 'student_tip' ? 'active' : ''}
                onClick={() => this.setActive('student_tip')}
                href="javascript:void(0)"
              >
                {trans`TIPS`}
              </a>
            </span>
          )}
        </div>

        <div className="personal-target-grouping-targets-body-description" dangerouslySetInnerHTML={{__html: description}} />
        <div className="personal-target-grouping-targets-body-content" dangerouslySetInnerHTML={{__html: content[active] }} />
      </Fragment>
    );
  }
}
